import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Download, FileCode, FileText, PackageX, Loader2 } from "lucide-react";
import { DashboardLayout } from "../../components/DashboardLayout";
import { EmptyState } from "../../components/Common";
import { MEMBER_MENU } from "../../lib/menus";
import { mediaUrl, typeLabel, formatDate } from "../../lib/format";
import api from "../../lib/api";

export default function MyProducts() {
  const [products, setProducts] = useState(null);
  const [busy, setBusy] = useState("");

  useEffect(() => {
    document.title = "Produk Saya - DS KODE";
    api.get("/member/products").then((r) => setProducts(r.data)).catch(() => setProducts([]));
  }, []);

  const download = async (id, type, slug) => {
    setBusy(`${id}-${type}`);
    try {
      const res = await api.get(`/download/${id}?type=${type}`, { responseType: "blob" });
      const cd = res.headers["content-disposition"] || "";
      const m = cd.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i);
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      const fallbackExt = type === "DOCUMENTATION" ? ".pdf" : ".zip";
      const filename = m ? decodeURIComponent(m[1].replace(/"$/, "")) : `${slug}-${type.toLowerCase()}${fallbackExt}`;
      a.href = url; a.download = filename; document.body.appendChild(a); a.click();
      setTimeout(() => { URL.revokeObjectURL(url); a.remove(); }, 1000);
      toast.success("Download berhasil");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Download gagal");
    } finally {
      setBusy("");
    }
  };

  return (
    <DashboardLayout title="Produk Saya" menu={MEMBER_MENU} testid="member-products">
      {products === null ? (
        <div className="grid sm:grid-cols-2 gap-4">{Array.from({ length: 4 }).map((_, i) => <div key={i} className="h-40 skeleton rounded-xl" />)}</div>
      ) : products.length === 0 ? (
        <EmptyState icon={PackageX} title="Belum ada produk." subtitle="Produk gratis & yang Anda beli akan muncul di sini." />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {products.map((p) => (
            <div key={p.id} className="card p-4 flex gap-4" data-testid={`my-product-${p.id}`}>
              <img src={mediaUrl(p.thumbnail)} alt="" className="h-24 w-32 rounded-lg object-cover shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-[11px] font-semibold text-indigo-600 uppercase">{typeLabel(p.product_type)}</p>
                <Link to={`/products/${p.slug}`} className="font-heading font-bold text-slate-900 hover:text-indigo-600 line-clamp-1">{p.title}</Link>
                <p className="text-xs text-slate-500 mb-2">v{p.version} · {formatDate(p.updated_at)}</p>
                <div className="flex flex-wrap gap-2">
                  <button onClick={() => download(p.id, "APPLICATION", p.slug)} disabled={busy} className="inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1.5 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-60" data-testid={`dl-app-${p.id}`}>{busy === `${p.id}-APPLICATION` ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Download className="h-3.5 w-3.5" />} Aplikasi</button>
                  <button onClick={() => download(p.id, "SOURCE_CODE", p.slug)} disabled={busy} className="inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1.5 rounded-lg border border-slate-200 text-slate-700 hover:bg-slate-50"><FileCode className="h-3.5 w-3.5" /> Source</button>
                  <button onClick={() => download(p.id, "DOCUMENTATION", p.slug)} disabled={busy} className="inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1.5 rounded-lg border border-slate-200 text-slate-700 hover:bg-slate-50"><FileText className="h-3.5 w-3.5" /> Docs</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </DashboardLayout>
  );
}
